// Import Link component
import Link from 'components/Link';
import MediaContainer from 'components/MediaContainer';
// Import config
import config from 'config';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { Col } from 'react-bootstrap';
// Import styles
import styles from './style.scss';

const Teaser = inject('MediahubStore', 'ViewStore')(observer(({ MediahubStore, ViewStore, channelTitle, channelLink, channelSize, items, index, fromDetail }) => {
  const isEnglish = _.startsWith(ViewStore.currentPath, '/en');
  let linkTo = 'channel'
  if ( fromDetail ) {
    linkTo = isEnglish ? 'channel' : ''
  }

  return (
  <section className={ViewStore.isMobile ? styles.teaserMobile + ' row' : styles.teaser + ' row ' + ( index === 1 && styles.highlighted ) } >
    { index === 1
    ? <div className={styles.background_color} />
    : null
  }

    <Col
      xs={12}
    >
      <header className={styles.header + ' clearfix'} >
        <h1
        className='col-xs-9'
        >{channelTitle}</h1 >
      </header >

      <div
      aria-label={channelTitle}
        aria-describedby={channelTitle}
        className={styles.content}
        role='section'
         >
        <ul
        className={'row'}
        >
          {
            items.slice(0,3).map( mc =>
              <li
                  key={`${mc.id}-${mc.channelId}`}
                  className={ViewStore.isMobile ? 'col-xs-12' : 'col-xs-6 col-sm-4'} >

                  <MediaContainer
                    mc={mc}
                    inTeaser={true}
                    isMobile={ViewStore.isMobile} />
                </li >
              )
          }
          {/* {
            _.map(items, (mc) => {
              return (
                <li
                  key={`${mc.id}-${mc.channelId}`}
                  className={ViewStore.isMobile ? 'col-xs-12' : 'col-xs-6 col-sm-4'} >

                  <MediaContainer
                    mc={mc}
                    inTeaser={true}
                    isMobile={ViewStore.isMobile} />
                </li >
              );
            })
          } */}
        </ul >
      </div >
      {
          !!channelLink
            ? (
              <div className={fromDetail ? styles.button_wrapper_left : styles.button_wrapper}>
                <Link to={linkTo}
                      channel={channelLink}
                      // className='col-xs-3'
                      >
                  {
                    fromDetail
                    ? ViewStore.get('backToOverview')
                    : ViewStore.get('showMore')
                  }
                </Link >
              </div>
            )
            : null
        }
    </Col >
  </section >
)
      }));

export default Teaser;



// WEBPACK FOOTER //
// ./src/components/Teaser/index.js